import React, { useState } from "react";

export default function AddOrder() {
  const [formData, setFormData] = useState({
    product: "",
    quantity: "",
    price: "",
    status: "",
    deliveryDate: "",
    customerName: "",
    customerAddress: "",
    isDelivery: false,
  });
  const [errors, setErrors] = useState({});

  const products = ["Product A", "Product B", "Product C"]; // Example options
  const statuses = ["Pending", "Completed", "Cancelled"];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateInputs = () => {
    const errors = {};
    if (!formData.product) errors.product = "Product is required";
    if (!formData.quantity || isNaN(formData.quantity) || formData.quantity <= 0)
      errors.quantity = "Valid quantity is required";
    if (!formData.price || isNaN(formData.price) || formData.price <= 0)
      errors.price = "Valid price is required";
    if (!formData.status) errors.status = "Status is required";
    if (!formData.deliveryDate) errors.deliveryDate = "Delivery date is required";
    if (!formData.customerName) errors.customerName = "Customer name is required";
    if (!formData.customerAddress) errors.customerAddress = "Customer address is required";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = () => {
    if (validateInputs()) {
      console.log("Order submitted:", formData);
      // Submission logic here
    }
  };

  return (
    <div className="bg-white shadow-lg rounded-lg p-6 max-w-4xl mx-auto">
      <div className="flex flex-col">
        <div className="flex flex-row items-center justify-between p-4 bg-gray-200 rounded-t-lg">
          <h3 className="font-semibold text-lg text-gray-700">New Order</h3>
          <button
            className="text-lightBlue-500 bg-transparent border border-solid border-lightBlue-500 hover:bg-lightBlue-500 hover:text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none ease-linear transition-all duration-150"
            type="button"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
        <form className="p-4 space-y-6">
          {/* Product */}
          <div className="mb-3">
            <select
              name="product"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.product}
              onChange={handleInputChange}
            >
              <option value="">Select Product</option>
              {products.map((product, index) => (
                <option key={index} value={product}>
                  {product}
                </option>
              ))}
            </select>
            {errors.product && <p className="text-red-500 text-xs mt-1">{errors.product}</p>}
          </div>

          {/* Quantity */}
          <div className="mb-3">
            <input
              type="number"
              name="quantity"
              placeholder="Quantity"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.quantity}
              onChange={handleInputChange}
            />
            {errors.quantity && <p className="text-red-500 text-xs mt-1">{errors.quantity}</p>}
          </div>

          {/* Price */}
          <div className="mb-3">
            <input
              type="number"
              name="price"
              placeholder="Price"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.price}
              onChange={handleInputChange}
            />
            {errors.price && <p className="text-red-500 text-xs mt-1">{errors.price}</p>}
          </div>

          {/* Delivery Date */}
          <div className="mb-3">
            <input
              type="date"
              name="deliveryDate"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.deliveryDate}
              onChange={handleInputChange}
            />
            {errors.deliveryDate && (
              <p className="text-red-500 text-xs mt-1">{errors.deliveryDate}</p>
            )}
          </div>

          {/* Customer Name */}
          <div className="mb-3">
            <input
              type="text"
              name="customerName"
              placeholder="Customer Name"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.customerName}
              onChange={handleInputChange}
            />
            {errors.customerName && (
              <p className="text-red-500 text-xs mt-1">{errors.customerName}</p>
            )}
          </div>

          {/* Customer Address */}
          <div className="mb-3">
            <textarea
              name="customerAddress"
              placeholder="Customer Address"
              className="px-2 py-1 text-gray-700 bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
              value={formData.customerAddress}
              onChange={handleInputChange}
            ></textarea>
            {errors.customerAddress && (
              <p className="text-red-500 text-xs mt-1">{errors.customerAddress}</p>
            )}
          </div>

          {/* Is Delivery */}
          <div className="mb-3 flex items-center">
            <input
              type="checkbox"
              name="isDelivery"
              className="mr-2"
              checked={formData.isDelivery}
              onChange={handleInputChange}
            />
            <label className="text-gray-700">Deliver Order?</label>
          </div>
        </form>
      </div>
    </div>
  );
}
